module.exports = __webpack_public_path__ + "img/b09.a1c23a7d.png";